import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import CustomerList from './CustomerList';
import EditCustomer from './EditCustomer/EditCustomer';

const Customers = () => {
  const { params } = useRouteMatch('/administration/customers/:customerId?');

  return (
    <Switch>
      <Route exact path="/administration/customers" component={CustomerList} />
      <Route path="/administration/customers/:customerId">
        <EditCustomer customerId={params.customerId} />
      </Route>
    </Switch>
  );
};

export default Customers;
